import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import {ToastsComponent} from './components/shared/toasts/toasts.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ToastsComponent],
  templateUrl: './app.component.html',
  host: {
    class: 'app-block app-fill-screen'
  }
})
export class AppComponent {
  title = 'sysprompthub_web';
}
